import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Download, Share, Plus } from 'lucide-react';

export function InstallButton() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [iosOpen, setIosOpen] = useState(false);

  const isStandalone = typeof window !== 'undefined' && (
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
  );
  const isIOS = typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (isStandalone || installed) return null;

  const click = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else if (isIOS) {
      setIosOpen(true);
    }
  };

  // Only show if we have a prompt (Android/Chrome/Edge) or it's iOS (manual instructions)
  if (!deferred && !isIOS) return null;

  return (
    <>
      <Button variant="outline" size="sm" onClick={click} data-testid="pwa-install-button" className="gap-1.5">
        <Download className="h-4 w-4" /> <span className="hidden sm:inline">Install app</span>
      </Button>
      <Dialog open={iosOpen} onOpenChange={setIosOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle className="font-heading">Install on iPhone / iPad</DialogTitle></DialogHeader>
          <ol className="space-y-3 text-sm">
            <li className="flex items-center gap-2">1. Tap the <Share className="h-4 w-4 inline" /> <b>Share</b> button in Safari.</li>
            <li className="flex items-center gap-2">2. Choose <Plus className="h-4 w-4 inline" /> <b>Add to Home Screen</b>.</li>
            <li>3. Tap <b>Add</b> — Lailany will appear on your home screen.</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
